import CallButton from './CallButton';
import { openZohoChat } from '../utils/openZohoChat';

export default function HelpBox({
  title = 'Family Tree Maker Giving You Trouble?',
  text = 'A friendly technician can sort it out with you by phone or live chat, on Windows or Mac, at any hour.',
}) {
  return (
    <div className="help-box">
      <h2>{title}</h2>
      <p>{text}</p>
      <div className="help-box__actions">
        <CallButton className="call-row--inline" />
        <button type="button" className="btn-outline" onClick={openZohoChat}>
          Start Live Chat
        </button>
      </div>
    </div>
  );
}
